(function () {
    var superproto = GUI.Forms.Validation.Validator.prototype;
    /**
    * JavaScript Graphical User Interface
    * Forms.Validation.Minlength implementation
    *
    * @author Eugene Lyulka
    * @version 2.0
    * @namespace GUI.Forms.Validation
    * @extends GUI.Forms.Validation.Validator
    */
    GUI.Forms.Validation.Minlength = Class.create();
    Object.extend(GUI.Forms.Validation.Minlength.prototype, superproto);

    /**
     * Text of the error message, default is 'i18n.GUI_VALIDATION_MINLENGTH'
     * @type String
     */
    GUI.Forms.Validation.Minlength.prototype.errorMessage = i18n(GUI.i18n.GUI_VALIDATION_MINLENGTH);

    /**
     * Type of the element, 'GUI.Forms.Validation.Minlength'
     * @type String
     */
    GUI.Forms.Validation.Minlength.prototype.elementType = 'GUI.Forms.Validation.Minlength';

    /**
     * Initialize validator
     * @param {Object} config configuration object
     */
    GUI.Forms.Validation.Minlength.prototype.initialize = function (config) {
        // Call parent method
        superproto.initialize.call(this, config);

        if (GUI.isSet(this.params)) {
            this.minLength = parseInt(this.params, 10);
        } else {
            throw new Error(this.elementType + ' error: required parameter not passed in config');
        }
    };

    /**
     * Validates value
     * @param {String|Number} value Value to validate
     * @return {Boolean} true - valid, false - invalid
     */
    GUI.Forms.Validation.Minlength.prototype.validateFunc = function (value) {
        return (value.trim().length >= this.minLength);
    };

    /**
     * Returns text of the error message
     * @returns {String} error message
     */
    GUI.Forms.Validation.Minlength.prototype.getErrorMessage = function () {
        //return GUI.formatString(this.errorMessage, this.minLength);
        return sprintf(this.errorMessage, this.minLength);
    };
}());